import {
  FETCH_LIST_KAFKA_LOG,
  FETCH_KAFKA_LOG,
  SAVE_KAFKA_LOG,
} from '../constants/constant_saga_types';

export function fetchKafkaLogList(silent, filters) {
  const type = FETCH_LIST_KAFKA_LOG;
  return { type, silent, filters };
}

export function fetchKafkaLog(id) {
  const type = FETCH_KAFKA_LOG;
  return { type, id };
}

export function saveKafkaLog(id) {
  const type = SAVE_KAFKA_LOG;
  return { type, id };
}
